import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { AppConfig } from "src/app/configs/app-config";
import { TipoParentescoEnum } from "src/app/core/enums/tipo-parentesco.enum";
import { DropdownLists } from "src/app/core/helpers/dropdown-lists/dropdown-lists";
import { ValidatorsCustom } from "src/app/core/helpers/validators-custom/validators-custom";
import { IBotonOpcion } from "src/app/core/models/formulario/boton-opcion.interface";
import {
  SolicitudAfiliacionObsoleta
} from "src/app/core/models/request/solicitud-afiliacion-obsoleta";
import { ApiCambioEstadoCivilInterface } from "src/app/core/models/response/api-cambio-estado-civil.interface";
import { SalarioConyuge } from "src/app/core/models/salario/salario-conyuge";
import { Pac, WresponseData } from "src/app/core/models/worker/wresponse-data";
import { GlobalService } from "src/app/core/services/global/global.service";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { ModalService } from "src/app/core/services/modal/modal.service";
import { ValidateData } from "src/app/core/utils/validate-data";
import { TipoIdentificacion } from "../../individual-afiliate-beneficiary/model/tipo-identificacion";
import { ListaTipoIdentificacion } from "../../individual-afiliate-beneficiary/model/tipo-identificacion.enum";
import { ValidacionesFechaNacimientoService } from "../../individual-afiliate-beneficiary/services/validaciones-fecha-nacimiento.service";
import { ValidacionesService } from "../../individual-afiliate-beneficiary/services/validaciones.service";
import { SeleccionarNuevoEstadoComponent } from "../seleccionar-nuevo-estado/seleccionar-nuevo-estado.component";

@Component({
  selector: "app-exponer-informacion",
  templateUrl: "./exponer-informacion.component.html",
  styleUrls: ["./exponer-informacion.component.scss"],
})
export class ExponerInformacionComponent implements OnInit {
  @Input() estadoCivilSeleccionado: { codigo: string; desc: string };
  @Output() eventoHijo = new EventEmitter();
  @Input() form: FormGroup;
  @Input() datosAfiliado?: WresponseData;
  @Input() habilitarConyugeCuidador?: boolean;
  @Output() eventoValidar = new EventEmitter<void>();



  public datosConyuge: Pac = null;
  finalizaRequestSvc: boolean = false;
  reglasCambioEstadoCivil: any;
  public filterConyuge: any;
  estadoActual;
  private afiliacion: SolicitudAfiliacionObsoleta;
  public tieneInformacionAdicional: boolean;
  public tieneSeccionRadioButton: boolean;

  public idModal = "m-load";

  public tiposIdentificacion: Array<TipoIdentificacion>;
  public genders: { name: string; value: number }[] = DropdownLists.genders;
  public occupations: { name: string; value: string }[] =
    DropdownLists.occupations;
  public salaryTypes: { name: string; value: string }[] =
    DropdownLists.salaryTypes;
  public documentCompanies: { name: string; value: string }[] =
    DropdownLists.documentCompanies;
  public minimaFecha = new Date();
  public maximaFecha = new Date();
  public salarioMinimoConyuge: number;
  public salarioMaximoConyuge: number;
  public etiquetasRadioButton: IBotonOpcion[] = [
    {
      id: `"rbCambioEstadocivil1`,
      texto: "SÍ, es la misma",
      ariaHidden: true,
      valor: "SI",
    },
    {
      id: `"rbCambioEstadocivil2`,
      texto: "NO, es diferente",
      ariaHidden: true,
      valor: "NO",
    },
  ];
  public dateFormat = new DatePipe("es-CO");
  public tieneSeccionDocumentos: boolean = true;
  public formRadioButton: FormGroup;
  private reasonSeleccionado: ApiCambioEstadoCivilInterface;

  public estadoRadioButton: boolean = false;
  private minimum_salary : number = 0;
  private _ObligatoriedadDocumentosService: any;

  constructor(
    private fb: FormBuilder,
    private validacionesSvc: ValidacionesService,
    private validacionesFechaNacimientoSvc: ValidacionesFechaNacimientoService,
    private globalService: GlobalService,
    private modalSvc: ModalService,
    private router: Router,
    private obtenerFuncionesNuevoEstadoCivil: SeleccionarNuevoEstadoComponent,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {


    // @ts-ignore
    this.minimum_salary = AppConfig.salarioMinimo(this.localStorageService);
    this.estadoActual =
      this.datosAfiliado.validacion_afiliado.afiliado.estadoCivil;
    this.tiposIdentificacion =
      this.validacionesSvc.obtenerDocumentosValidos_cambioEstadoCivil(
        this.datosAfiliado
      ).tiposIdentificacion.filter(tipo => tipo.valor != 'CO1P') ;

    if (this.datosAfiliado.validacion_afiliado.pacs) {
      this.filterConyuge = this.datosAfiliado.validacion_afiliado.pacs.filter(
        (x) => x.relacion.codigo === "SUB-0002"
      );
      if (this.filterConyuge.length > 0) {
        this.datosConyuge = this.filterConyuge[0];
      }
    }




    this.comportamiento();

    this.detectarCambiosEnFormulario();

    //this.formConyuge.get("estadoCivil").disable();
  }

  private detectarCambiosEnFormulario() {
    const regex = /^(\d{6,8}|\d{10})$/;

    this.formConyuge
      .get("TipoIdConyuge")
      .valueChanges.subscribe((value: string) => {
      if (
        !this.formConyuge.get("TipoIdConyuge").disabled &&
        !ValidateData.emptyObject(value)
      ) {
        const reglaTipoDocumento = this.tiposIdentificacion.find(
          (x) => x.valor == value
        );
        if (!this.filterConyuge) {
          this.formConyuge.get("NumIdConyuge").setValue("");
        }
        this.formConyuge
          .get("NumIdConyuge")
          .setValidators([
            Validators.required,
            Validators.minLength(reglaTipoDocumento.min),
            Validators.maxLength(reglaTipoDocumento.max),
            Validators.pattern(reglaTipoDocumento.expresionRegular),
            ValidatorsCustom.patternCustom(
              ListaTipoIdentificacion.CC.codigo == reglaTipoDocumento.valor
                ? regex
                : null,
              "El valor ingresado no es correcto"
            ),
            ValidatorsCustom.documentoDiferenteTrabajador(() =>
              this.form.get("trabajador.NumIdTrabajador")?.value
            ),
          ]);

        this.formConyuge.get("TipoIdConyuge").setValidators([Validators.required]);

        this.formConyuge.get("FechaNaciConyuge").enable();
        // Esta condicional es para habilitar la validación de fechas solo cuando se pueda editar el formulario
        if (this.tieneInformacionAdicional) {
          this.obtenerValidacionRangoDeEdad(value);
          this.formConyuge
            .get("TipoIdEmpresaConyuge")
            .valueChanges.subscribe((value: string) => {
            if (!ValidateData.emptyObject(value)) {
              let validaciones;
              if (value == "CO1N") {
                let varRegex = /^[0-9]{9}$/;
                validaciones = ValidatorsCustom.patternCustom(
                  varRegex,
                  "Debe contener 9 digitos"
                );
              } else {
                let reglaTipoDocumento = this.tiposIdentificacion.find(
                  (x) => x.valor == value
                );
                validaciones = Validators.pattern(
                  reglaTipoDocumento.expresionRegular
                );
              }
              this.formConyuge.get("NumIdEmpresaConyuge").clearValidators();
              this.formConyuge
                .get("NumIdEmpresaConyuge")
                .setValidators([Validators.required, validaciones]);
              this.formConyuge
                .get("NumIdEmpresaConyuge")
                .updateValueAndValidity();
            }
          });
        }
      }
    });

    this.formConyuge
    this.formConyuge
      .get("OcupacionConyuge")
      .valueChanges.subscribe((value: string) => {
      if (
        !this.formConyuge.get("TipoIdConyuge").disabled &&
        !ValidateData.emptyObject(value)
      ) {
        this.cambioTipoDeOcupacion(value);
      }
    });

    this.formConyuge
      .get("TipoSalarioConyuge")
      .valueChanges.subscribe((value: number) => {
      if (!ValidateData.emptyObject(value)) {
        this.cambiarRangoSalario(value);
      }
    });



    this.formConyuge
      .get("NumIdEmpresaConyuge")
      .valueChanges.subscribe((value: string) => {
      if (!ValidateData.emptyString(value)) {
        this.calculateDigVerC(value);
      }
    });

    this.formConyuge
      .get("Apellido1Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Apellido1Conyuge")
        .setValue(value ? value.toUpperCase() : "", { emitEvent: false });
    });

    this.formConyuge
      .get("Apellido2Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Apellido2Conyuge")
        .setValue(value ? value.toUpperCase() : "", { emitEvent: false });
    });

    this.formConyuge
      .get("Nombre1Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Nombre1Conyuge")
        .setValue(value ? value.toUpperCase() : "", { emitEvent: false });
    });
    this.formConyuge
      .get("Nombre2Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Nombre2Conyuge")
        .setValue(value ? value.toUpperCase() : "", { emitEvent: false });
    });


    this.formConyuge.get("RazonEmpresaConyuge").clearValidators();
    this.formConyuge.get("NumIdEmpresaConyuge").setValidators([Validators.required]);
    this.formConyuge.get("NumIdEmpresaConyuge").updateValueAndValidity();
    this.formConyuge.get("RazonEmpresaConyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("RazonEmpresaConyuge")
        .setValue(value ? value.toUpperCase() : null, { emitEvent: false });
    });






    this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");

    let regext = /^\d*$/;

    this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "", [
      ValidatorsCustom.patternCustom(regext,
        "El valor ingresado no debe tener caracteres especiales"
      ),
    ]);

    this.formConyuge.get("SalarioConyuge").valueChanges.subscribe((value: number) => {
      const tipoSalario = this.determinarTipoSalario(value);
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, tipoSalario);
    });
  }

  determinarTipoSalario(salario: number): string {
    const rangosSalarioConyuge = SalarioConyuge.obtenerSalarioConyuge(this.localStorageService);
    const SALARIO_MINIMO_ESPECIAL = rangosSalarioConyuge["01"].salarioMinimo;
    return salario >= SALARIO_MINIMO_ESPECIAL ? "01" : "02";
  }

  private cambioTipoDeOcupacion(value: string) {
    // Empleado(a)
    this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
    this.cambiarEstadoCampoFormulario("SalarioConyuge", false, "");

    if (value === "02") {
      this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", true, "", [
        Validators.required,
        Validators.maxLength(40),
        Validators.pattern("^[a-zA-Z0-9]([^s]?[a-zA-Z0-9])+$"),
      ]);
      this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "");
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
      return;
    }

    // Hogar o Desempleado
    if (value === "01" || value === "04") {
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
      return;
    }

    // Independiente o Pensionado(a)
    if (value === "03" || value === "05") {
      this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "02");
      return;
    }
  }

  private cambiarEstadoCampoFormulario(
    key: string,
    isEnable: boolean,
    value: any,
    arrayValidations?: ValidatorFn[]
  ) {
    if (isEnable) {
      this.formConyuge.get(key).enable();
    }
    if (!isEnable) {
      this.formConyuge.get(key).disable();
    }
    this.formConyuge.get(key).setValue(value);
    this.formConyuge.get(key).clearValidators();
    if (arrayValidations) {
      this.formConyuge.get(key).setValidators(arrayValidations);
    }
    this.formConyuge.get(key).markAsUntouched();
    this.formConyuge.get(key).updateValueAndValidity();
  }


  cambiarRangoSalario(value) {
    if (value) {
      const rangosSalarioConyuge = SalarioConyuge.obtenerSalarioConyuge(this.localStorageService);
      this.salarioMinimoConyuge = rangosSalarioConyuge[value].salarioMinimo;
      this.salarioMaximoConyuge = rangosSalarioConyuge[value].salarioMaximo;
      this.formConyuge
        .get("SalarioConyuge")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarRangoSalarioConyuge(
            this.salarioMinimoConyuge,
            this.salarioMaximoConyuge
          ),

        ]);
    }
  }



  showCalendar(event: any) {
    document.getElementById(event.target.id).click();
  }

  /**
   * Funcion para calcular el digito de verificacion de una empresa dependiendo de su nit
   * @param nit Nit de la empresa
   */
  calculateDigVerC(nit: string) {
    let codV;
    if (nit) {
      codV = this.globalService.calculerDV(nit);
    }
    this.formConyuge.get("DigVerEmpresaConyuge").setValue(codV);
    this.formConyuge.get("DigVerEmpresaConyuge").updateValueAndValidity();
  }

  regresarEstado() {
    this.formConyuge.reset();
    this.eventoHijo.emit();
  }

  comportamiento() {
    this.reglasCambioEstadoCivil =
      this.obtenerFuncionesNuevoEstadoCivil.reglasEstadoCivil(
        this.estadoActual,
        this.estadoCivilSeleccionado
      );
    this.tieneInformacionAdicional =
      this.reglasCambioEstadoCivil.tieneInformacionAdicional;
    this.tieneSeccionRadioButton =
      this.reglasCambioEstadoCivil.tieneSeccionRadioButton;

    if (!this.tieneInformacionAdicional) {
      if (this.filterConyuge) {
        this.setearValoresParaFormulario();
      }
    }

    if (this.tieneSeccionRadioButton) {
      this.formRadioButton = this.fb.group({});
      this.formRadioButton.addControl(
        "esCorrectoConyuge",
        this.fb.control(null, Validators.required)
      );
      let conyuge = this.formConyuge as FormGroup;
      conyuge.addControl("formRadioButton", this.formRadioButton);
      this.tieneSeccionDocumentos = true;

      this.formConyuge
        .get("formRadioButton")
        .get("esCorrectoConyuge")
        .valueChanges.subscribe((data) => {
        data === "SI"
          ? (this.tieneSeccionDocumentos = true)
          : (this.tieneSeccionDocumentos = true);
        data === "NO"
          ? (this.estadoRadioButton = true)
          : (this.estadoRadioButton = true);
      });
    }
  }

  setearValoresParaFormulario() {



    this.formConyuge.reset({
      reason: this.reglasCambioEstadoCivil.idJson,
      TipoIdConyuge: this.datosConyuge.tipoDocumento,
      NumIdConyuge: this.datosConyuge.numeroDocumento,
      Apellido1Conyuge: this.datosConyuge.apellido,
      Apellido2Conyuge: this.datosConyuge.segundoApellido,
      Nombre1Conyuge: this.datosConyuge.primerNombre,
      Nombre2Conyuge: this.datosConyuge.segundoNombre,
      FechaNaciConyuge: this.dateFormat.transform( this.datosConyuge.fechaNacimiento,  "yyyy-MM-dd", "+0100"),
      GeneroConyuge: this.datosConyuge.genero,
    });
    this.formConyuge.disable();
  }

  private obtenerValidacionRangoDeEdad(value: string) {
    this.formConyuge.get("FechaNaciConyuge").setValue(null);
    let minimaFechaYMaximaFecha: any;
    if (value)
    {
      minimaFechaYMaximaFecha =
        this.validacionesFechaNacimientoSvc.reglasSegunParentescoYDocumentoDeIndentificacion(
          this.datosAfiliado,
          TipoParentescoEnum.CONYUGE,
          this.formConyuge.get("TipoIdConyuge").value,
          "false"
        );


      this.minimaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaDesde
        : null;

      this.maximaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaHasta
        : null;

      this.formConyuge
        .get("FechaNaciConyuge")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarFechaMinimoYMaximo(
            this.minimaFecha,
            this.maximaFecha
          ),
        ]);
    }
  }

  get formConyuge() {
    return this.form.get("conyuge") as FormGroup;
  }

  onlyAllowNumbers(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);
    const isDigit = /^\d$/.test(inputChar);
    const input = event.target as HTMLInputElement;
    if (!isDigit || input.value.length >= 9) {
      event.preventDefault();
    }
  }

  checkAndValidate() {
    this.eventoValidar.emit();
  }
}
